import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
@Component({
    selector: 't4-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})
export class ConfirmComponent {

  public okBtnText = 'BTN.OK';
  public cancelBtnText = 'BTN.CANCEL';

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.cancelonly === undefined) {
      data.cancelonly = false;
    }
    if (data.okonly === undefined) {
      data.okonly = false;
    }

    if (data.okBtnText) {
      this.okBtnText = data.okBtnText;
    }
    if (data.cancelBtnText) {
      this.cancelBtnText = data.cancelBtnText;
    }
  }

  public getSafeHtml(): string {
    if (!this.data || !this.data.message) return '';
    
    // Escape ALL HTML first
    const escaped = this.data.message
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    // Restore only allowed tags
    return escaped
      .replace(/&lt;br\s*\/?&gt;/gi, '<br>')
      .replace(/&lt;\/br&gt;/gi, '</br>')
      .replace(/&lt;b&gt;/gi, '<b>')
      .replace(/&lt;\/b&gt;/gi, '</b>')
      .replace(/&lt;code&gt;/gi, '<code>')
      .replace(/&lt;\/code&gt;/gi, '</code>')
      .replace(/&lt;a\b(.*?)&gt;/gi, '<a$1>')
      .replace(/&lt;\/a&gt;/gi, '</a>')
      .replace(/&lt;font\b(.*?)&gt;/gi, '<font$1>')
      .replace(/&lt;\/font&gt;/gi, '</font>')
      .replace(/&lt;u&gt;/gi, '<u>')
      .replace(/&lt;\/u&gt;/gi, '</u>')
      .replace(/&lt;i&gt;/gi, '<i>')
      .replace(/&lt;\/i&gt;/gi, '</i>')
      .replace(/&lt;strong&gt;/gi, '<strong>')
      .replace(/&lt;\/strong&gt;/gi, '</strong>')
      .replace(/&lt;h([1-6])\b(.*?)&gt;/gi, '<h$1$2>')
      .replace(/&lt;\/h([1-6])&gt;/gi, '</h$1>')
      .replace(/&lt;p&gt;/gi, '<p>')
      .replace(/&lt;\/p&gt;/gi, '</p>')
      .replace(/&lt;li&gt;/gi, '<li>')
      .replace(/&lt;\/li&gt;/gi, '</li>')
      .replace(/&lt;ul&gt;/gi, '<ul>')
      .replace(/&lt;\/ul&gt;/gi, '</ul>');
  }
}
